import { render, staticRenderFns } from "./PinchEffectViz.vue?vue&type=template&id=85994ff0&scoped=true"
import script from "./PinchEffectViz.vue?vue&type=script&lang=js"
export * from "./PinchEffectViz.vue?vue&type=script&lang=js"
import style0 from "./PinchEffectViz.vue?vue&type=style&index=0&id=85994ff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85994ff0",
  null
  
)

export default component.exports